import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/icon6.png'
import _imports_1 from '../assets/icon7.png'
import _imports_2 from '../assets/icon8.png'
import _imports_3 from '../assets/icon9.png'
import _imports_4 from '../assets/icon10.png'
import _imports_5 from '../assets/icon11.png'
import _imports_6 from '../assets/icon12.png'


const _hoisted_1 = {
  key: 0,
  class: "text-danger mt-5 d-flex align-self-center flex-column text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "root"
}
const _hoisted_3 = {
  class: "nav nav-tabs fixed-top bg-white ps-2 pt-1 pe-2",
  style: {"margin-top":"40px"}
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "d-flex flex-fill justify-content-end" }
const _hoisted_8 = ["onSelect", "value"]
const _hoisted_9 = {
  class: "pt-2 container p-0",
  style: {"margin-top":"25px"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "me-3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg" }
const _hoisted_16 = { class: "card mt-2 mt-lg-2" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-8 p-3 d-flex flex-column" }
const _hoisted_20 = { class: "d-flex flex-row" }
const _hoisted_21 = { class: "flex-fill" }
const _hoisted_22 = { class: "h1 text-white" }
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = { class: "col-4 p-0" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "col-lg" }
const _hoisted_27 = { class: "card mt-3 mt-lg-2" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "d-flex justify-content-center" }
const _hoisted_30 = { class: "d-flex flex-column" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  class: "h2",
  style: {"line-height":"10px"}
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "card mt-3" }
const _hoisted_38 = { class: "card-header card-header-exam" }
const _hoisted_39 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "teethTable" }
const _hoisted_44 = { class: "border-0" }
const _hoisted_45 = { class: "teethTable" }
const _hoisted_46 = { class: "border-0" }
const _hoisted_47 = {
  class: "text-center mt-3",
  style: {"margin-left":"11px"}
}
const _hoisted_48 = { class: "teethTable" }
const _hoisted_49 = { class: "border-0" }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { class: "teethTable" }
const _hoisted_52 = { class: "border-0" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg" }
const _hoisted_55 = { class: "card mt-2" }
const _hoisted_56 = { class: "card-header card-header-exam" }
const _hoisted_57 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_58 = { class: "card-body row gx-2" }
const _hoisted_59 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = {
  class: "table table-sm c-table-bordered",
  style: {"table-layout":"fixed"}
}
const _hoisted_62 = ["textContent"]
const _hoisted_63 = ["textContent"]
const _hoisted_64 = ["textContent"]
const _hoisted_65 = ["textContent"]
const _hoisted_66 = ["textContent"]
const _hoisted_67 = ["textContent"]
const _hoisted_68 = {
  key: 1,
  class: "col-6"
}
const _hoisted_69 = {
  class: "table table-sm c-table-bordered",
  style: {"table-layout":"fixed"}
}
const _hoisted_70 = ["textContent"]
const _hoisted_71 = ["textContent"]
const _hoisted_72 = ["textContent"]
const _hoisted_73 = ["textContent"]
const _hoisted_74 = ["textContent"]
const _hoisted_75 = ["textContent"]
const _hoisted_76 = { class: "col-lg" }
const _hoisted_77 = { class: "card mt-2" }
const _hoisted_78 = { class: "card-header card-header-exam" }
const _hoisted_79 = {
  class: "position-absolute text-end pt-2 pe-2",
  style: {"top":"0px","left":"0px","width":"100%"}
}
const _hoisted_80 = { class: "card-body row gx-2" }
const _hoisted_81 = {
  key: 0,
  class: "table table-sm c-table-bordered"
}
const _hoisted_82 = { class: "col-6" }
const _hoisted_83 = {
  class: "table c-table-bordered table-sm",
  style: {"table-layout":"fixed"}
}
const _hoisted_84 = ["textContent"]
const _hoisted_85 = ["textContent"]
const _hoisted_86 = ["textContent"]
const _hoisted_87 = ["textContent"]
const _hoisted_88 = ["textContent"]
const _hoisted_89 = ["textContent"]
const _hoisted_90 = ["textContent"]
const _hoisted_91 = {
  key: 1,
  class: "col-6"
}
const _hoisted_92 = {
  class: "table c-table-bordered table-sm",
  style: {"table-layout":"fixed"}
}
const _hoisted_93 = ["textContent"]
const _hoisted_94 = ["textContent"]
const _hoisted_95 = ["textContent"]
const _hoisted_96 = ["textContent"]
const _hoisted_97 = ["textContent"]
const _hoisted_98 = ["textContent"]
const _hoisted_99 = ["textContent"]
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-lg" }
const _hoisted_102 = { class: "card mt-2" }
const _hoisted_103 = { class: "card-body row" }
const _hoisted_104 = { class: "col-12" }
const _hoisted_105 = { class: "table c-table-bordered table-sm" }
const _hoisted_106 = {
  key: 0,
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_107 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_108 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_109 = { class: "col-lg" }
const _hoisted_110 = { class: "card mt-2" }
const _hoisted_111 = { class: "card-body row" }
const _hoisted_112 = { class: "col-12" }
const _hoisted_113 = { class: "table c-table-bordered table-sm" }
const _hoisted_114 = {
  key: 0,
  style: {"width":"20%"},
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_115 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_116 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_117 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_118 = {
  key: 0,
  style: {"width":"20%"},
  class: "bg-light text-gray"
}
const _hoisted_119 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_120 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_121 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_122 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_123 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_124 = { class: "card mt-2" }
const _hoisted_125 = { class: "card-body row" }
const _hoisted_126 = { class: "col-12" }
const _hoisted_127 = { class: "table c-table-bordered table-sm" }
const _hoisted_128 = {
  key: 0,
  class: "border-start-0 border-end-0 border-top-0"
}
const _hoisted_129 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_130 = {
  key: 0,
  class: "bg-light text-gray"
}
const _hoisted_131 = { class: "card mt-2" }
const _hoisted_132 = { class: "card-body" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "col-sm-6 d-flex justify-content-center" }
const _hoisted_135 = { style: {"max-width":"500px"} }
const _hoisted_136 = { class: "col-sm-6 d-flex justify-content-center" }
const _hoisted_137 = { style: {"max-width":"500px"} }
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { class: "d-flex flex-row justify-content-center mb-3" }
const _hoisted_140 = { class: "card" }
const _hoisted_141 = { class: "card mt-2" }
const _hoisted_142 = { class: "card mt-2" }
const _hoisted_143 = { class: "card mt-2" }
const _hoisted_144 = { class: "card mt-2" }
const _hoisted_145 = { class: "card mt-2" }
const _hoisted_146 = { class: "card mt-2" }
const _hoisted_147 = { key: 2 }
const _hoisted_148 = { class: "d-flex flex-row justify-content-center mb-3" }
const _hoisted_149 = { class: "card" }
const _hoisted_150 = { class: "card mt-2" }
const _hoisted_151 = { class: "card mt-2" }
const _hoisted_152 = { class: "card" }
const _hoisted_153 = { class: "card mt-2" }
const _hoisted_154 = { class: "card mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shishiki_component = _resolveComponent("shishiki-component")!
  const _component_teeth_exam = _resolveComponent("teeth-exam")!
  const _component_teeth_radar_chart = _resolveComponent("teeth-radar-chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.currentKenshin.kenshinDate && _ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 健診データがありません。 "))
      : _createCommentVNode("", true),
    (_ctx.currentKenshin.kenshinDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===0, 'bg-light': _ctx.tabIndex===0}]),
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabIndex=0))
              }, "健診結果", 2)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===1, 'bg-light': _ctx.tabIndex===1}]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabIndex=1))
              }, "詳細説明", 2)
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {active: _ctx.tabIndex===2, 'bg-light': _ctx.tabIndex===2}]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabIndex=2))
              }, "歯周病説明", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("select", {
                style: {"width":"100px"},
                class: "form-select form-select-sm mb-1",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChange($event)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kenshinList, (row, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    onSelect: ($event: any) => (_ctx.andleChange($event, index)),
                    value: row.kenshinDate,
                    key: index
                  }, _toDisplayString(_ctx.FU.datetimeFormat(row.kenshinDate, 'YYYY/MM/DD')), 41, _hoisted_8))
                }), 128))
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.tabIndex===0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, "歯科医師：" + _toDisplayString(_ctx.currentKenshin.ishiName), 1),
                      _createElementVNode("span", null, "衛生士：" + _toDisplayString(_ctx.currentKenshin.eiseishiName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                          _createElementVNode("span", { class: "h4" }, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              class: "exam-icon"
                            }),
                            _createTextVNode(" あなたの口腔状態は ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("span", {
                                    class: "btn btn-lg p-3 w-100",
                                    style: _normalizeStyle({'background-color': _ctx.SogoHantei.getEnum('' + _ctx.currentKenshin.sogoHantei).color})
                                  }, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.SogoHantei.getName('' + _ctx.currentKenshin.sogoHantei)), 1)
                                  ], 4)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.currentKenshin.sogoHanteiComment), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                class: "float-end img-fluid",
                                alt: "Vue logo",
                                src: require(`@/assets/exam_${_ctx.currentKenshin.sogoHantei}.png`)
                              }, null, 8, _hoisted_25)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                          _createElementVNode("span", { class: "h4" }, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              class: "exam-icon"
                            }),
                            _createTextVNode(" 歯科推定年齢 ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              (_ctx.currentKenshin.suiteiNenrei!==null && _ctx.currentKenshin.suiteiNenrei!==undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _cache[8] || (_cache[8] = _createTextVNode(" あなたの歯科推定年齢は", -1)),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.FU.numberFormat(_ctx.currentKenshin.suiteiNenrei)), 1),
                                    _cache[9] || (_cache[9] = _createTextVNode("歳です。 ", -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, " 今回の健診では歯科推定年齢を算出できませんでした。 ")),
                              (_ctx.existsPrev)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    (_ctx.prevKenshin.suiteiNenrei!==null && _ctx.prevKenshin.suiteiNenrei!==undefined)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, " ※前回の健診では" + _toDisplayString(_ctx.FU.numberFormat(_ctx.prevKenshin.suiteiNenrei)) + "歳でした。 ", 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_36, " ※前回の健診では歯科推定年齢を算出できませんでした。 "))
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mt-4" }, " 歯科推定年齢は歯科健診データを基にオリジナルで算出した年齢です。 ", -1))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "h4" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "exam-icon"
                        }),
                        _createTextVNode(" 歯の状態 ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          class: "btn btn-light",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showShishiDoc=!_ctx.showShishiDoc))
                        }, _toDisplayString(_ctx.showShishiDoc ? '閉じる' : '記号説明'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.showShishiDoc)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_41, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                style: {"width":"100px"},
                                class: "bg-light"
                              }, "記号"),
                              _createElementVNode("th", { class: "bg-light" }, "説明")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Co"),
                              _createElementVNode("td", { class: "text-start" }, "初期の虫歯で要観察のもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "C1"),
                              _createElementVNode("td", { class: "text-start" }, "虫歯１度　歯の表面だけか歯の中の部分に少しだけ虫歯が進行したのもで、痛みを感じない")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "C2"),
                              _createElementVNode("td", { class: "text-start" }, "虫歯２度　歯の中の部分に虫歯が進行したもので、水や冷たいものがしみる")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "C3"),
                              _createElementVNode("td", { class: "text-start" }, "虫歯３度　神経まで虫歯が進んだもので、ひどく痛むことが多い")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "C4"),
                              _createElementVNode("td", { class: "text-start" }, "虫歯４度　歯の大部分が侵食され、歯の根元だけが残っている状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "IIC"),
                              _createElementVNode("td", { class: "text-start" }, "治療の済んだ歯に、虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "破折"),
                              _createElementVNode("td", { class: "text-start" }, "歯牙の一部分が虫歯以外の理由でかけている状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "脱落"),
                              _createElementVNode("td", { class: "text-start" }, "治療していた部分が取れてしまった状態（虫歯になっていない）")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "WSD"),
                              _createElementVNode("td", { class: "text-start" }, "歯の根元がすり減ったりへこんだりした状態　主に歯の磨き方が悪くて歯にできるクサビ状の凹み")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "X"),
                              _createElementVNode("td", { class: "text-start" }, "歯が抜けてしまったところのことで、補う必要がある部分")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, [
                                _createElementVNode("svg", {
                                  width: "17",
                                  height: "17",
                                  class: "m-0"
                                }, [
                                  _createElementVNode("g", { transform: "scale(0.7)" }, [
                                    _createElementVNode("ellipse", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      cx: "6.9",
                                      cy: "7.15",
                                      rx: "6.36",
                                      ry: "6.594"
                                    }),
                                    _createElementVNode("line", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      x1: "2.379",
                                      y1: "2.5",
                                      x2: "11.555",
                                      y2: "11.677"
                                    }),
                                    _createElementVNode("line", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      x1: "2.2",
                                      y1: "11.67",
                                      x2: "11.338",
                                      y2: "2.532"
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", { class: "text-start" }, "欠損はしているが、補う必要がない部分")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "m"),
                              _createElementVNode("td", { class: "text-start" }, "モビリティー　グラグラしている歯のこと")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "AF"),
                              _createElementVNode("td", { class: "text-start" }, "銀色の詰め物を入れた歯　虫歯にアマルガム（水銀の合金）をつめたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "AFIIC"),
                              _createElementVNode("td", { class: "text-start" }, "AF の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "In"),
                              _createElementVNode("td", { class: "text-start" }, "インレー　虫歯に金属の詰め物をつめたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "InIIC"),
                              _createElementVNode("td", { class: "text-start" }, "In の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "RF"),
                              _createElementVNode("td", { class: "text-start" }, "白いプラスチックの詰め物　虫歯に歯と同色のつめものをしたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "RFIIC"),
                              _createElementVNode("td", { class: "text-start" }, "RF の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Ce"),
                              _createElementVNode("td", { class: "text-start" }, "一時的にセメントを詰めた歯　セメントを暫間的につめたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "CeIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Ce の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "On"),
                              _createElementVNode("td", { class: "text-start" }, "大きな金属の詰め物　Ｃ2以上の虫歯を修復したもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "OnIIC"),
                              _createElementVNode("td", { class: "text-start" }, "On の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Cr"),
                              _createElementVNode("td", { class: "text-start" }, "かぶせ物（冠）　虫歯に金属冠をかぶせたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "CrIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Cr の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Br"),
                              _createElementVNode("td", { class: "text-start" }, "歯が抜けた部分を両側の歯に橋のようにかぶせたもの　歯がないとき、両隣りまたは片隣りの歯に金属をかぶせて歯が抜けてしまったところを補ったもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "BrIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Br の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "ダミー"),
                              _createElementVNode("td", { class: "text-start" }, "ダミー　歯が抜けた部分を両側の歯に橋のようにかぶせたもので欠損した部分を補った人工歯（ダミーにはインプラントも含まれます）")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Jcr"),
                              _createElementVNode("td", { class: "text-start" }, "ジャケット。かぶせ物（冠）　虫歯に、歯と同色の冠をかぶせたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "JcIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Jcr の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Vcr"),
                              _createElementVNode("td", { class: "text-start" }, "白い部分のあるかぶせ物　虫歯に金属で裏打ちをした歯と同色の冠をかぶせたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "VcIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Vcr の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "MB"),
                              _createElementVNode("td", { class: "text-start" }, "見た目が自然な陶器と金属のかぶせ物　自然歯の色をした陶材を金属冠に焼き付けたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "MBIIC"),
                              _createElementVNode("td", { class: "text-start" }, "MB の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Post"),
                              _createElementVNode("td", { class: "text-start" }, "前歯のさし歯　前歯の虫歯に、さし歯をしたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "PoIIC"),
                              _createElementVNode("td", { class: "text-start" }, "Post の処置歯に虫歯がもう一度できてしまったした状態")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "PD"),
                              _createElementVNode("td", { class: "text-start" }, "部分入れ歯（部分入歯）　歯が残っていて欠損部に入歯をしたもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "FD"),
                              _createElementVNode("td", { class: "text-start" }, "総入れ歯（総入歯）　歯が全部なく、入歯したもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "Tr"),
                              _createElementVNode("td", { class: "text-start" }, "現在治療中の歯のこと")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, [
                                _createElementVNode("svg", {
                                  width: "17",
                                  height: "17",
                                  class: "m-0"
                                }, [
                                  _createElementVNode("g", { transform: "scale(0.8)" }, [
                                    _createElementVNode("path", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      d: "M0.236,2.345c0,0,2.863-1.72,6.132-1.72 c3.27,0,6.796,1.72,6.796,1.72"
                                    }),
                                    _createElementVNode("line", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      x1: "4.328",
                                      y1: "2.682",
                                      x2: "2.453",
                                      y2: "11.775"
                                    }),
                                    _createElementVNode("line", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      x1: "7.328",
                                      y1: "2.682",
                                      x2: "5.453",
                                      y2: "11.775"
                                    }),
                                    _createElementVNode("line", {
                                      fill: "none",
                                      stroke: "#000000",
                                      "stroke-miterlimit": "10",
                                      x1: "10.328",
                                      y1: "2.682",
                                      x2: "8.453",
                                      y2: "11.775"
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", { class: "text-start" }, "智歯（親知らず）が歯肉の表面に正常に出ていないもの")
                            ], -1),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", { class: "text-center" }, "乳A～E、乳"),
                              _createElementVNode("td", { class: "text-start" }, "乳歯（子どもの歯）")
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_ctx.existsPrev)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _cache[14] || (_cache[14] = _createTextVNode(" 前回 ", -1)),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "border-0 text-center",
                                    style: {"height":"10px!important"},
                                    key: index
                                  }, _toDisplayString(row), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upper, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "display bg-light",
                                    key: index
                                  }, [
                                    _createVNode(_component_shishiki_component, {
                                      codes: _ctx.prevKenshin[row],
                                      "history-flg": "true"
                                    }, null, 8, ["codes"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createTextVNode(" 今回 ", -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "border-0 text-center",
                                style: {"height":"10px!important"},
                                key: index
                              }, _toDisplayString(row), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upper, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "shishiki-cell"
                              }, [
                                _createVNode(_component_shishiki_component, {
                                  codes: _ctx.currentKenshin[row],
                                  colors: _ctx.currentKenshin.shishikiUpperColor[index]
                                }, null, 8, ["codes", "colors"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_teeth_exam, {
                          "current-border-color": "ccc",
                          "current-label": "xxx",
                          "current-data": "[1,2,3]",
                          exams: _ctx.teethInfo
                        }, null, 8, ["exams"])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[16] || (_cache[16] = _createTextVNode(" 今回 ", -1)),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "border-0 text-center",
                                style: {"height":"10px!important"},
                                key: index
                              }, _toDisplayString(row), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lower, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "shishiki-cell"
                              }, [
                                _createVNode(_component_shishiki_component, {
                                  codes: _ctx.currentKenshin[row],
                                  colors: _ctx.currentKenshin.shishikiLowerColor[index]
                                }, null, 8, ["codes", "colors"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      (_ctx.existsPrev)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _cache[17] || (_cache[17] = _createTextVNode(" 前回 ", -1)),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tns, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "border-0 text-center",
                                    style: {"height":"10px!important"},
                                    key: index
                                  }, _toDisplayString(row), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lower, (row, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "display bg-light",
                                    key: index
                                  }, [
                                    _createVNode(_component_shishiki_component, {
                                      codes: _ctx.prevKenshin[row],
                                      "history-flg": "true"
                                    }, null, 8, ["codes"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "h4" }, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              class: "exam-icon"
                            }),
                            _createTextVNode(" 歯周病（歯槽膿漏） ")
                          ], -1)),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("button", {
                              class: "btn btn-light",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNoroDoc=!_ctx.showNoroDoc))
                            }, _toDisplayString(_ctx.showNoroDoc ? '閉じる' : '記号説明'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          (_ctx.showNoroDoc)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_59, [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", {
                                    style: {"width":"200px"},
                                    class: "bg-light"
                                  }, "記号"),
                                  _createElementVNode("th", { class: "bg-light" }, "説明")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "Ｐマイナス、Ｐ０～１、Ｐ１"),
                                  _createElementVNode("td", { class: "text-start" }, "正常")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "Ｐ１～２、Ｐ２"),
                                  _createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの３分の１程度まで消失したもの")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "Ｐ２～３、Ｐ３"),
                                  _createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの２分の１程度まで消失したもの")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "Ｐ３～４、Ｐ４"),
                                  _createElementVNode("td", { class: "text-start" }, "歯を支えている骨が歯根の長さの３分の２程度まで消失したものもしくは、それ以上 と認めるもの")
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_60, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
                              _createElementVNode("span", { class: "text-center" }, "今回")
                            ], -1)),
                            _createElementVNode("table", _hoisted_61, [
                              _cache[20] || (_cache[20] = _createElementVNode("tr", null, [
                                _createElementVNode("td", null, "右上"),
                                _createElementVNode("td", null, "上前歯"),
                                _createElementVNode("td", null, "左上")
                              ], -1)),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(0)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(0))
                                }, null, 12, _hoisted_62),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(1)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(1))
                                }, null, 12, _hoisted_63),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(2)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(2))
                                }, null, 12, _hoisted_64)
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(3)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(3))
                                }, null, 12, _hoisted_65),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(4)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(4))
                                }, null, 12, _hoisted_66),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(5)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getPHantei(5))
                                }, null, 12, _hoisted_67)
                              ]),
                              _cache[21] || (_cache[21] = _createElementVNode("tr", null, [
                                _createElementVNode("td", null, "右下"),
                                _createElementVNode("td", null, "下前歯"),
                                _createElementVNode("td", null, "左下")
                              ], -1))
                            ])
                          ]),
                          (_ctx.existsPrev)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
                                  _createElementVNode("span", { class: "text-center" }, "前回")
                                ], -1)),
                                _createElementVNode("table", _hoisted_69, [
                                  _cache[23] || (_cache[23] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, "右上"),
                                    _createElementVNode("td", null, "上前歯"),
                                    _createElementVNode("td", null, "左上")
                                  ], -1)),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(0))
                                    }, null, 8, _hoisted_70),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(1))
                                    }, null, 8, _hoisted_71),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(2))
                                    }, null, 8, _hoisted_72)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(3))
                                    }, null, 8, _hoisted_73),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(4))
                                    }, null, 8, _hoisted_74),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getPHantei(5))
                                    }, null, 8, _hoisted_75)
                                  ]),
                                  _cache[24] || (_cache[24] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, "右下"),
                                    _createElementVNode("td", null, "下前歯"),
                                    _createElementVNode("td", null, "左下")
                                  ], -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "d-flex flex-row h4 justify-content-center mb-0" }, [
                            _createElementVNode("img", {
                              src: _imports_2,
                              class: "exam-icon"
                            }),
                            _createElementVNode("div", { class: "text-start mt-2" }, [
                              _createTextVNode("ＣＰＩＴＮ"),
                              _createElementVNode("br"),
                              _createTextVNode("（歯周ポケット測定）")
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("button", {
                              class: "btn btn-light",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCpitnDoc=!_ctx.showCpitnDoc))
                            }, _toDisplayString(_ctx.showCpitnDoc ? '閉じる' : '記号説明'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          (_ctx.showCpitnDoc)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_81, [...(_cache[27] || (_cache[27] = [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", {
                                    style: {"width":"50px"},
                                    class: "bg-light"
                                  }, "記号"),
                                  _createElementVNode("th", { class: "bg-light" }, "説明")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "0"),
                                  _createElementVNode("td", { class: "text-start" }, "歯ぐきが健康な状態（TYPE：０）")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "1"),
                                  _createElementVNode("td", { class: "text-start" }, "歯ぐきが少し赤くなった状態（TYPE：１）")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "2"),
                                  _createElementVNode("td", { class: "text-start" }, "歯石がついている状態（TYPE：２）")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "3"),
                                  _createElementVNode("td", { class: "text-start" }, "歯周病が少し進んでいる状態（TYPE：２）")
                                ], -1),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", { class: "text-center" }, "4"),
                                  _createElementVNode("td", { class: "text-start" }, "歯周病がかなり進んでいる状態（TYPE：３）")
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_82, [
                            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
                              _createElementVNode("span", { class: "text-center" }, "今回")
                            ], -1)),
                            _createElementVNode("table", _hoisted_83, [
                              _cache[28] || (_cache[28] = _createElementVNode("tr", null, [
                                _createElementVNode("td", null, "右上"),
                                _createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "上前歯"),
                                _createElementVNode("td", null, "左上"),
                                _createElementVNode("td", null, "TYPE")
                              ], -1)),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(0)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(0))
                                }, null, 12, _hoisted_84),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(1)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(1))
                                }, null, 12, _hoisted_85),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(2)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(2))
                                }, null, 12, _hoisted_86),
                                _createElementVNode("td", {
                                  rowspan: "3",
                                  class: "align-middle",
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.typeIroKbn)}),
                                  textContent: _toDisplayString(_ctx.currentKenshin.type)
                                }, null, 12, _hoisted_87)
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(3)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(3))
                                }, null, 12, _hoisted_88),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(4)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(4))
                                }, null, 12, _hoisted_89),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getCpitnColor(5)}),
                                  textContent: _toDisplayString(_ctx.kenshinService.getCpitn(5))
                                }, null, 12, _hoisted_90)
                              ]),
                              _cache[29] || (_cache[29] = _createElementVNode("tr", null, [
                                _createElementVNode("td", null, "右下"),
                                _createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "下前歯"),
                                _createElementVNode("td", null, "左下")
                              ], -1))
                            ])
                          ]),
                          (_ctx.existsPrev)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-center" }, [
                                  _createElementVNode("span", { class: "text-center" }, "前回")
                                ], -1)),
                                _createElementVNode("table", _hoisted_92, [
                                  _cache[31] || (_cache[31] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, "右上"),
                                    _createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "上前歯"),
                                    _createElementVNode("td", null, "左上"),
                                    _createElementVNode("td", null, "TYPE")
                                  ], -1)),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(0))
                                    }, null, 8, _hoisted_93),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(1))
                                    }, null, 8, _hoisted_94),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(2))
                                    }, null, 8, _hoisted_95),
                                    _createElementVNode("td", {
                                      rowspan: "3",
                                      class: "align-middle bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshin.type)
                                    }, null, 8, _hoisted_96)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(3))
                                    }, null, 8, _hoisted_97),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(4))
                                    }, null, 8, _hoisted_98),
                                    _createElementVNode("td", {
                                      class: "bg-light text-gray",
                                      textContent: _toDisplayString(_ctx.prevKenshinService.getCpitn(5))
                                    }, null, 8, _hoisted_99)
                                  ]),
                                  _cache[32] || (_cache[32] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, "右下"),
                                    _createElementVNode("td", { style: {"padding-left":"0px","padding-right":"0px"} }, "下前歯"),
                                    _createElementVNode("td", null, "左下")
                                  ], -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                          _createElementVNode("span", { class: "h4" }, [
                            _createElementVNode("img", {
                              src: _imports_3,
                              class: "exam-icon"
                            }),
                            _createTextVNode(" 特殊健診 ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("table", _hoisted_105, [
                              _createElementVNode("tr", null, [
                                _cache[34] || (_cache[34] = _createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1)),
                                _cache[35] || (_cache[35] = _createElementVNode("td", { class: "border-start-0 border-end-0 border-top-0" }, "今回", -1)),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_106, "前回"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[36] || (_cache[36] = _createElementVNode("td", { class: "text-start" }, "口腔粘膜", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.kokuNenmakuIroKbn)})
                                }, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.currentKenshin.kokuNenmaku)), 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_107, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.prevKenshin.kokuNenmaku)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[37] || (_cache[37] = _createElementVNode("td", { class: "text-start" }, "酸蝕症度", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.sanshokuShodoIroKbn)})
                                }, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.currentKenshin.sanshokuShodo)), 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_108, _toDisplayString(_ctx.kenshinService.getTokushuKenshinName(_ctx.prevKenshin.sanshokuShodo)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                          _createElementVNode("span", { class: "h4" }, [
                            _createElementVNode("img", {
                              src: _imports_4,
                              class: "exam-icon"
                            }),
                            _createTextVNode(" う蝕歯（虫歯）等 ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("table", _hoisted_113, [
                              _createElementVNode("tr", null, [
                                _cache[39] || (_cache[39] = _createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1)),
                                _cache[40] || (_cache[40] = _createElementVNode("td", {
                                  style: {"width":"20%"},
                                  class: "border-start-0 border-end-0 border-top-0"
                                }, "今回", -1)),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_114, "前回"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[41] || (_cache[41] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "Ｃ1（初期う蝕）注意", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c1IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c1Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(_ctx.prevKenshin.c1Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[42] || (_cache[42] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "Ｃ2（早期要治療）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c2IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c2Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_116, _toDisplayString(_ctx.prevKenshin.c2Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[43] || (_cache[43] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "Ｃ3（重度要治療）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c3IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c3Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_117, _toDisplayString(_ctx.prevKenshin.c3Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[44] || (_cache[44] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "Ｃ4（重度要治療）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.c4IroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.c4Honsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_118, _toDisplayString(_ctx.prevKenshin.c4Honsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[45] || (_cache[45] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "IIＣ（重度要治療）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.iicIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.iicHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_119, _toDisplayString(_ctx.prevKenshin.iicHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[46] || (_cache[46] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "脱（要相談歯）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.datsurakuIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.datsurakuHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_120, _toDisplayString(_ctx.prevKenshin.datsurakuHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[47] || (_cache[47] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "Ｔｒ（治療途中歯）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.trIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.trHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_121, _toDisplayString(_ctx.prevKenshin.trHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[48] || (_cache[48] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "×（欠損歯）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.yohotetsushiIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.yohotetsushi) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_122, _toDisplayString(_ctx.prevKenshin.yohotetsushi) + "本", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[49] || (_cache[49] = _createElementVNode("td", {
                                  class: "text-start",
                                  style: {"width":"60%"}
                                }, "WSD（楔状欠損歯）", -1)),
                                _createElementVNode("td", {
                                  style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.wsdIroKbn)})
                                }, _toDisplayString(_ctx.currentKenshin.wsdHonsu) + "本", 5),
                                (_ctx.existsPrev)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_123, _toDisplayString(_ctx.prevKenshin.wsdHonsu) + "本", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_124, [
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                      _createElementVNode("span", { class: "h4" }, [
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "exam-icon"
                        }),
                        _createTextVNode(" 歯石沈着度および清掃状態 ")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("table", _hoisted_127, [
                          _createElementVNode("tr", null, [
                            _cache[51] || (_cache[51] = _createElementVNode("td", { class: "text-end border-start-0 border-end-0 border-top-0" }, null, -1)),
                            _cache[52] || (_cache[52] = _createElementVNode("td", { class: "border-start-0 border-end-0 border-top-0" }, "今回", -1)),
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_128, "前回"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[53] || (_cache[53] = _createElementVNode("td", { class: "text-start" }, "歯石沈着度 ", -1)),
                            _createElementVNode("td", {
                              style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.shisekiChinchakuIroKbn)})
                            }, _toDisplayString(_ctx.kenshinService.getShisekiChinchakudoName(_ctx.currentKenshin.shisekiChinchaku)), 5),
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_129, _toDisplayString(_ctx.prevKenshinService.getShisekiChinchakudoName(_ctx.prevKenshin.shisekiChinchaku)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[54] || (_cache[54] = _createElementVNode("td", { class: "text-start" }, "清掃状態", -1)),
                            _createElementVNode("td", {
                              style: _normalizeStyle({'background-color': _ctx.kenshinService.getColor(_ctx.currentKenshin.seisoJotaiIroKbn)})
                            }, _toDisplayString(_ctx.kenshinService.getSeisoJotaiName(_ctx.currentKenshin.seisoJotai)), 5),
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_130, _toDisplayString(_ctx.prevKenshinService.getSeisoJotaiName(_ctx.prevKenshin.seisoJotai)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "card-header card-header-exam" }, [
                      _createElementVNode("span", { class: "h4" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "exam-icon"
                        }),
                        _createTextVNode(" チャート ")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", _hoisted_135, [
                            true
                              ? (_openBlock(), _createBlock(_component_teeth_radar_chart, {
                                  key: 0,
                                  "current-data": [_ctx.currentKenshin.shisekiDev, _ctx.currentKenshin.pMaxDev, _ctx.currentKenshin.typeDev,
                  _ctx.currentKenshin.kessonshiDev, _ctx.currentKenshin.wsdDev, _ctx.currentKenshin.ushokushiDev],
                                  "current-label": "今回",
                                  "current-border-color": "lightblue"
                                }, null, 8, ["current-data"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("div", _hoisted_137, [
                            (_ctx.existsPrev)
                              ? (_openBlock(), _createBlock(_component_teeth_radar_chart, {
                                  key: 0,
                                  "current-data": [_ctx.prevKenshin.shisekiDev, _ctx.prevKenshin.pMaxDev, _ctx.prevKenshin.typeDev,
                  _ctx.prevKenshin.kessonshiDev, _ctx.prevKenshin.wsdDev, _ctx.prevKenshin.ushokushiDev],
                                  "current-label": "前回",
                                  "current-border-color": "lightsalmon"
                                }, null, 8, ["current-data"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "card-footer bg-white" }, [
                      _createTextVNode(" 上記図表は個人データを基にあたなの口腔状態をオリジナルにチャート化したものです。"),
                      _createElementVNode("br"),
                      _createTextVNode("各項目とも平均値を上回るように正しい口腔管理を心掛けてください。 ")
                    ], -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tabIndex===1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('1')}])
                    }, null, 4),
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "ps-2 pe-2" }, "異常なし", -1)),
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('2')}])
                    }, null, 4),
                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "ps-2 pe-2" }, "注意", -1)),
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('3')}])
                    }, null, 4),
                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "ps-2 pe-2" }, "早期治療", -1)),
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('4')}])
                    }, null, 4),
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "ps-2 pe-2" }, "要治療", -1))
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 初期う蝕（注意） ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku1IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku1Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 早期要治療歯 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku2IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku2Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 重度要治療歯 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.ushoku3IroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.ushoku3Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_143, [
                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 欠損歯 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.yohotetsushiIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.kessonshiComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 楔状欠損歯(WSD) ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.wsdIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.wsdComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 清掃状態 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.seisoJotaiIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.seisoJotaiComment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _cache[68] || (_cache[68] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 口腔粘膜 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.iroKbnMap.get(_ctx.currentKenshin.kokuNenmakuIroKbn)})
                    }, _toDisplayString(_ctx.currentKenshin.kokuNenmakuComment), 5)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tabIndex===2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                  _createElementVNode("div", _hoisted_148, [
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('1')}])
                    }, null, 4),
                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "ps-2 pe-2" }, "異常なし", -1)),
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('2')}])
                    }, null, 4),
                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "ps-2 pe-2" }, "注意", -1)),
                    _createElementVNode("div", {
                      class: "border-1 border",
                      style: _normalizeStyle([{"width":"18px"}, {'background-color': _ctx.iroKbnMap.get('4')}])
                    }, null, 4),
                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "ps-2 pe-2" }, "要治療", -1))
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 右上 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(0)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei1Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _cache[73] || (_cache[73] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 上前歯 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(1)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei2Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _cache[74] || (_cache[74] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 左上 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(2)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei3Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _cache[75] || (_cache[75] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 右下 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(3)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei4Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _cache[76] || (_cache[76] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 下前歯 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(4)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei5Comment), 5)
                  ]),
                  _createElementVNode("div", _hoisted_154, [
                    _cache[77] || (_cache[77] = _createElementVNode("div", { class: "card-header bg-primary text-white" }, " 左下 ", -1)),
                    _createElementVNode("div", {
                      class: "card-body rounded-bottom",
                      style: _normalizeStyle({'background-color': _ctx.kenshinService.getPHanteiColor(5)})
                    }, _toDisplayString(_ctx.currentKenshin.pHantei6Comment), 5)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}